import { Component, HostListener, Input, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

export type AdminReviewWidgetInfoModel = {
  finalComment: string;
  turndownComment: string;
  turndownReasons: { title: string }[];
};

@Component({
  selector: "app-admin-review-widget-info-modal",
  templateUrl: "./admin-review-widget-info-modal.component.html",
  styleUrls: ["./admin-review-widget-info-modal.component.scss"],
})
export class AdminReviewWidgetInfoModalComponent implements OnInit {
  @Input() info: AdminReviewWidgetInfoModel;
  @Input() title: string;
  @Input() showFinalComment = false;
  @Input() showTurndownReason = false;

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit() {
    this.title = this.config.data?.title;
    this.info = this.config.data?.info;
    this.showFinalComment = this.config.data?.showFinalComment;
    this.showTurndownReason = this.config.data?.showTurndownReason;
  }
  
  // close on navigation
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.dismiss();
  }

  public close() {
    this.dialogRef.close(false);
  }

  public dismiss() {
    this.dialogRef.close(null);
  }
}
